
import { Code, Briefcase, Palette, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ServicesSection = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: Code,
      title: t('services.it.title'),
      description: t('services.it.description'),
      image: 'https://public.readdy.ai/ai/img_res/b7228b96d052278f7babcbab7a7a47fd.jpg'
    },
    {
      icon: Briefcase,
      title: t('services.business.title'),
      description: t('services.business.description'),
      image: 'https://readdy.ai/api/search-image?query=Business%20professionals%20in%20a%20modern%20conference%20room%20discussing%20project%20management%20with%20charts%20and%20graphs%20on%20whiteboard%2C%20leadership%20training%20session%20with%20certificates%20and%20business%20documents%2C%20professional%20corporate%20environment&width=400&height=300&seq=business-service&orientation=landscape'
    },
    {
      icon: Palette,
      title: t('services.design.title'),
      description: t('services.design.description'),
      image: 'https://readdy.ai/api/search-image?query=Creative%20designer%20working%20on%20graphic%20design%20projects%20with%20color%20palettes%20and%20design%20tools%2C%20modern%20creative%20studio%20with%20UI%20UX%20mockups%20and%20digital%20marketing%20materials%2C%20artistic%20workspace%20with%20design%20certificates&width=400&height=300&seq=design-service&orientation=landscape'
    },
    {
      icon: Globe,
      title: t('services.language.title'),
      description: t('services.language.description'),
      image: 'https://readdy.ai/api/search-image?query=International%20language%20learning%20classroom%20with%20flags%20from%20different%20countries%2C%20students%20learning%20foreign%20languages%20with%20books%20and%20digital%20devices%2C%20multicultural%20educational%20environment%20with%20language%20certificates&width=400&height=300&seq=language-service&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
                <div className="relative h-48">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
